

// // app/components/form-sections/StudentInstitutionSection.jsx
// "use client";
// import { useMemo, useState, useEffect } from "react";
// import Field from "../ui/Field";
// import Select from "../ui/Select";
// import { HistoryDatalist } from "../ui/HistoryDatalist";

// const CUSTOM_VALUE = "__custom__";

// export default function StudentInstitutionSection({
//   form,
//   setField,
//   pushHistory,
//   history,
//   colleges = [],
//   majorsByCategory = {},
//   SPORT_OPTIONS = [],
// }) {
//   const [open, setOpen] = useState(false);
//   const [programSelect, setProgramSelect] = useState("");
//   const [sportSelect, setSportSelect] = useState("");

//   // Merge history + provided colleges for the datalist
//   const collegeListMerged = useMemo(
//     () => Array.from(new Set([...(history["college"] || []), ...(colleges || [])])),
//     [history, colleges]
//   );

//   // Build a quick lookup for majors (case-insensitive)
//   const majorsSet = useMemo(() => {
//     const flat = Object.values(majorsByCategory || {}).flat() || [];
//     return new Set(flat.map((m) => String(m).toLowerCase()));
//   }, [majorsByCategory]);

//   // Keep the "Program / Major" select in sync with existing form.program
//   useEffect(() => {
//     const cur = String(form.program || "").trim();
//     if (!cur) {
//       setProgramSelect("");
//       return;
//     }
//     setProgramSelect(majorsSet.has(cur.toLowerCase()) ? cur : CUSTOM_VALUE);
//   }, [form.program, majorsSet]);

//   // Keep the "Sport" select in sync with existing form.sport
//   useEffect(() => {
//     const cur = String(form.sport || "").trim();
//     if (!cur) {
//       setSportSelect("");
//       return;
//     }
//     const sportSet = new Set((SPORT_OPTIONS || []).map((s) => String(s).toLowerCase()));
//     setSportSelect(sportSet.has(cur.toLowerCase()) ? cur : CUSTOM_VALUE);
//   }, [form.sport, SPORT_OPTIONS]);

//   // ---------- Auto-enrich the AI prompt with selected dropdowns (incl. sport) ----------
//   useEffect(() => {
//     // Only help when the user hasn't provided their own prompt
//     if (String(form.ai_experience_prompt || "").trim()) return;

//     const parts = [];
//     if (form.program) parts.push(`include the student's interest in ${form.program}`);
//     if (form.sport) parts.push(`mention their participation in ${form.sport}`);
//     if (form.college) parts.push(`where relevant, align to ${form.college}'s academic community`);

//     if (parts.length) {
//       const autoPrompt =
//         `Write a concise paragraph from a high-school counselor describing specific experiences ` +
//         `working with the student (advising, academic planning, leadership, service), professional tone; ` +
//         `avoid greetings/signatures. Please ${parts.join(", ")}.`;
//       setField("ai_experience_prompt")({ target: { value: autoPrompt } });
//       // Save to history so it appears in the prompt's history dropdown
//       pushHistory?.("ai_experience_prompt", autoPrompt);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [form.program, form.sport, form.college]);
//   // -------------------------------------------------------------------------------------

//   return (
//     <div className="rounded-2xl border border-gray-200 bg-white mt-6">
//       <button
//         type="button"
//         onClick={() => setOpen((v) => !v)}
//         className="w-full flex items-center justify-between px-4 py-3 sm:px-5 border-b border-gray-200 hover:bg-slate-100"
//         aria-expanded={open}
//         aria-controls="school-panel"
//       >
//         <span className="text-[13px] sm:text-sm font-semibold text-slate-900">
//           Student / Institution
//         </span>
//         <span className="inline-flex items-center gap-2 text-sm text-gray-700">
//           {open ? "Hide" : "Show"}
//           <svg
//             className={`h-5 w-5 transition-transform ${open ? "rotate-180" : ""}`}
//             viewBox="0 0 20 20"
//             fill="currentColor"
//             aria-hidden
//           >
//             <path
//               fillRule="evenodd"
//               d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
//               clipRule="evenodd"
//             />
//           </svg>
//         </span>
//       </button>

//       {open && (
//         <div id="school-panel" className="p-4 sm:p-5 grid gap-4">
//           <div className="grid gap-4 sm:grid-cols-2">
//             <Field label="Student">
//               <input
//                 placeholder="e.g., Jordan Lee"
//                 className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
//                 value={form.student}
//                 onChange={setField("student")}
//                 onBlur={(e) => pushHistory("student", e.target.value)}
//                 list="hist-student"
//               />
//               <HistoryDatalist id="hist-student" values={history["student"] || []} />
//             </Field>

//             <Field label="College (type or choose below)">
//               <input
//                 placeholder="Type a college, or pick below"
//                 className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
//                 value={form.college}
//                 onChange={setField("college")}
//                 onBlur={(e) => pushHistory("college", e.target.value)}
//                 list="collegeAllList"
//               />
//               <HistoryDatalist id="collegeAllList" values={collegeListMerged} />
//             </Field>
//           </div>

//           {/* Sport */}
//           <Field
//             label="Sport (optional)"
//             hint="Included in the AI Draft Experience and referenced in the letter."
//           >
//             <div className="grid gap-2">
//               <Select
//                 value={sportSelect}
//                 onChange={(e) => {
//                   const v = e.target.value;
//                   setSportSelect(v);
//                   if (!v) {
//                     setField("sport")({ target: { value: "" } });
//                     return;
//                   }
//                   if (v !== CUSTOM_VALUE) {
//                     setField("sport")({ target: { value: v } });
//                     pushHistory("sport", v);
//                   } else {
//                     // CUSTOM_VALUE: show custom input; keep current form.sport as-is
//                     if (!form.sport) setField("sport")({ target: { value: "" } });
//                   }
//                 }}
//               >
//                 <option value="">— Select a sport —</option>
//                 {SPORT_OPTIONS.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//                 <option value={CUSTOM_VALUE}>Custom / Other…</option>
//               </Select>

//               {sportSelect === CUSTOM_VALUE && (
//                 <>
//                   <input
//                     placeholder="Type a sport, e.g., Men's Soccer"
//                     className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
//                     value={form.sport}
//                     onChange={setField("sport")}
//                     onBlur={(e) => pushHistory("sport", e.target.value)}
//                     list="sportList"
//                   />
//                   <HistoryDatalist id="sportList" values={history["sport"] || []} />
//                 </>
//               )}
//             </div>
//           </Field>

//           {/* Program / Major */}
//           <Field
//             label="Program / Major"
//             hint="Pick a major or choose Other to type your own. Your choice will be included in the AI Draft Experience."
//           >
//             <Select
//               value={programSelect}
//               onChange={(e) => {
//                 const v = e.target.value;
//                 setProgramSelect(v);
//                 setField("program")({ target: { value: v === CUSTOM_VALUE ? "" : v } });
//                 if (v && v !== CUSTOM_VALUE) pushHistory("program", v);
//               }}
//             >
//               <option value="">— Select a major —</option>
//               {Object.entries(majorsByCategory).map(([group, majors]) => (
//                 <optgroup key={group} label={`— ${group} —`}>
//                   {majors.map((m) => (
//                     <option key={m} value={m}>
//                       {m}
//                     </option>
//                   ))}
//                 </optgroup>
//               ))}
//               <option value={CUSTOM_VALUE}>Other / Custom…</option>
//             </Select>

//             {programSelect === CUSTOM_VALUE && (
//               <>
//                 <input
//                   className="mt-2 w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
//                   placeholder="Type your program / major"
//                   value={form.program}
//                   onChange={setField("program")}
//                   onBlur={(e) => pushHistory("program", e.target.value)}
//                   list="hist-program"
//                 />
//                 <HistoryDatalist id="hist-program" values={history["program"] || []} />
//               </>
//             )}
//           </Field>
//         </div>
//       )}
//     </div>
//   );
// }


// app/components/form-sections/StudentInstitutionSection.jsx
"use client";
import { useMemo, useState, useEffect } from "react";
import Field from "../ui/Field";
import Select from "../ui/Select";
import { HistoryDatalist } from "../ui/HistoryDatalist";

const CUSTOM_VALUE = "__custom__";
const SPORT_TAG_PREFIX = "Sport:"; // internal marker so we can replace without touching other items

export default function StudentInstitutionSection({
  form,
  setField,
  pushHistory,
  history,
  colleges = [],
  majorsByCategory = {},
  SPORT_OPTIONS = [],
}) {
  const [open, setOpen] = useState(false);
  const [programSelect, setProgramSelect] = useState("");
  const [sportSelect, setSportSelect] = useState("");

  // Merge history + provided colleges for the datalist
  const collegeListMerged = useMemo(
    () => Array.from(new Set([...(history["college"] || []), ...(colleges || [])])),
    [history, colleges]
  );

  // Build a quick lookup for majors (case-insensitive)
  const majorsSet = useMemo(() => {
    const flat = Object.values(majorsByCategory || {}).flat() || [];
    return new Set(flat.map((m) => String(m).toLowerCase()));
  }, [majorsByCategory]);

  // Keep "Program / Major" select in sync with form.program
  useEffect(() => {
    const cur = String(form.program || "").trim();
    if (!cur) {
      setProgramSelect("");
      return;
    }
    setProgramSelect(majorsSet.has(cur.toLowerCase()) ? cur : CUSTOM_VALUE);
  }, [form.program, majorsSet]);

  // Keep "Sport" select in sync with form.sport
  useEffect(() => {
    const cur = String(form.sport || "").trim();
    if (!cur) {
      setSportSelect("");
      return;
    }
    const sportSet = new Set((SPORT_OPTIONS || []).map((s) => String(s).toLowerCase()));
    setSportSelect(sportSet.has(cur.toLowerCase()) ? cur : CUSTOM_VALUE);
  }, [form.sport, SPORT_OPTIONS]);

  // ---------- Ensure sport is represented in extracurriculars for AI generation ----------
  const upsertSportInExtracurriculars = (sportVal) => {
    const list = Array.isArray(form.extracurriculars) ? [...form.extracurriculars] : [];
    // Remove any existing "Sport:" entry we previously injected
    const filtered = list.filter((x) => typeof x !== "string" || !x.startsWith(`${SPORT_TAG_PREFIX} `));
    if (sportVal && sportVal.trim()) {
      filtered.unshift(`${SPORT_TAG_PREFIX} ${sportVal.trim()}`);
    }
    setField("extracurriculars")({ target: { value: filtered } });
  };

  // When form.sport changes (via select or custom), sync to extracurriculars
  useEffect(() => {
    upsertSportInExtracurriculars(form.sport || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.sport]);
  // --------------------------------------------------------------------------------------

  // ---------- Auto-enrich the AI "experience paragraph" prompt (sport-aware) ----------
  useEffect(() => {
    // Only help when the user hasn't provided their own prompt
    if (String(form.ai_experience_prompt || "").trim()) return;

    const parts = [];
    if (form.program) parts.push(`include the student's interest in ${form.program}`);
    if (form.sport) parts.push(`mention their participation in ${form.sport}`);
    if (form.college) parts.push(`where relevant, align to ${form.college}'s academic community`);

    if (parts.length) {
      const autoPrompt =
        `Write a concise paragraph from a high-school counselor describing specific experiences ` +
        `working with the student (advising, academic planning, leadership, service), professional tone; ` +
        `avoid greetings/signatures. Please ${parts.join(", ")}.`;
      setField("ai_experience_prompt")({ target: { value: autoPrompt } });
      pushHistory?.("ai_experience_prompt", autoPrompt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.program, form.sport, form.college]);
  // -------------------------------------------------------------------------------------

  // Helpers to set sport AND keep extracurriculars in sync immediately on change
  const handleSportSelectChange = (v) => {
    setSportSelect(v);
    if (!v) {
      setField("sport")({ target: { value: "" } });
      upsertSportInExtracurriculars("");
      return;
    }
    if (v !== CUSTOM_VALUE) {
      setField("sport")({ target: { value: v } });
      upsertSportInExtracurriculars(v);
      pushHistory("sport", v);
    } else {
      if (!form.sport) setField("sport")({ target: { value: "" } });
    }
  };

  const handleSportCustomBlur = (val) => {
    pushHistory("sport", val);
    upsertSportInExtracurriculars(val);
  };

  return (
    <div className="rounded-2xl border border-gray-200 bg-white mt-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 sm:px-5 border-b border-gray-200 hover:bg-slate-100"
        aria-expanded={open}
        aria-controls="school-panel"
      >
        <span className="text-[13px] sm:text-sm font-semibold text-slate-900">
          Student / Institution
        </span>
        <span className="inline-flex items-center gap-2 text-sm text-gray-700">
          {open ? "Hide" : "Show"}
          <svg
            className={`h-5 w-5 transition-transform ${open ? "rotate-180" : ""}`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </button>

      {open && (
        <div id="school-panel" className="p-4 sm:p-5 grid gap-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Student">
              <input
                placeholder="e.g., Jordan Lee"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.student}
                onChange={setField("student")}
                onBlur={(e) => pushHistory("student", e.target.value)}
                list="hist-student"
              />
              <HistoryDatalist id="hist-student" values={history["student"] || []} />
            </Field>

            <Field label="College (type or choose below)">
              <input
                placeholder="Type a college, or pick below"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.college}
                onChange={setField("college")}
                onBlur={(e) => pushHistory("college", e.target.value)}
                list="collegeAllList"
              />
              <HistoryDatalist id="collegeAllList" values={collegeListMerged} />
            </Field>
          </div>

          {/* Sport */}
          <Field
            label="Sport (optional)"
            hint="Included in the AI draft and sent as an extracurricular to the generator."
          >
            <div className="grid gap-2">
              <Select
                value={sportSelect}
                onChange={(e) => handleSportSelectChange(e.target.value)}
              >
                <option value="">— Select a sport —</option>
                {SPORT_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
                <option value={CUSTOM_VALUE}>Custom / Other…</option>
              </Select>

              {sportSelect === CUSTOM_VALUE && (
                <>
                  <input
                    placeholder="Type a sport, e.g., Men's Soccer"
                    className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                    value={form.sport}
                    onChange={setField("sport")}
                    onBlur={(e) => handleSportCustomBlur(e.target.value)}
                    list="sportList"
                  />
                  <HistoryDatalist id="sportList" values={history["sport"] || []} />
                </>
              )}
            </div>
          </Field>

          {/* Program / Major */}
          <Field
            label="Program / Major"
            hint="Pick a major or choose Other to type your own. Your choice is included in the AI request."
          >
            <Select
              value={programSelect}
              onChange={(e) => {
                const v = e.target.value;
                setProgramSelect(v);
                setField("program")({ target: { value: v === CUSTOM_VALUE ? "" : v } });
                if (v && v !== CUSTOM_VALUE) pushHistory("program", v);
              }}
            >
              <option value="">— Select a major —</option>
              {Object.entries(majorsByCategory).map(([group, majors]) => (
                <optgroup key={group} label={`— ${group} —`}>
                  {majors.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </optgroup>
              ))}
              <option value={CUSTOM_VALUE}>Other / Custom…</option>
            </Select>

            {programSelect === CUSTOM_VALUE && (
              <>
                <input
                  className="mt-2 w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                  placeholder="Type your program / major"
                  value={form.program}
                  onChange={setField("program")}
                  onBlur={(e) => pushHistory("program", e.target.value)}
                  list="hist-program"
                />
                <HistoryDatalist id="hist-program" values={history["program"] || []} />
              </>
            )}
          </Field>
        </div>
      )}
    </div>
  );
}
